import React from 'react';

const TimeOfSettlementCard = ({settlementTime}) => {
    return (
        <div className="card-container time-of-settlement-card">
            <div className="card-title-section">
                <span>Time of settlement </span>
            </div>
            <div className="card-content-section">
                <span>{settlementTime}</span>
            </div>
        </div>
    );
};

export default TimeOfSettlementCard;
